import { styled } from '@linaria/react';

export const OffersDialogWrapper = styled.div`
  background: transparent;
  padding-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: min(calc(100vw - 60px), 350px);
`;

export const OffersDialogCloseBtn = styled.div`
  position: relative;

  width: 100%;
  height: 25px;
  background: transparent;
  display: flex;
  justify-content: flex-end;

  & svg {
    width: 25px;
  }

  & span {
    display: inline-block;
    width: 12px;
    height: 12px;
    top: -12px;
    position: absolute;
    right: 0;
  }
`;
